export default "/images/facebookTwo.svg?8f230e41464b46065d3893a9e9edc5ce";